import { render, staticRenderFns } from "./search-modal-customer-personal.vue?vue&type=template&id=6027ac4c&scoped=true&"
import script from "./search-modal-customer-personal.vue?vue&type=script&lang=ts&"
export * from "./search-modal-customer-personal.vue?vue&type=script&lang=ts&"
import style0 from "./search-modal-customer-personal.vue?vue&type=style&index=0&id=6027ac4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027ac4c",
  null
  
)

export default component.exports